import { createGlobalStyle } from "styled-components";
import "normalize.css";

const GlobalStyle = createGlobalStyle`
  :root {
    --color-bg: #f3ecdf;
    --color-surface: #faf6ed;
    --color-surface-2: #fff;
    --color-primary: #173f35;
    --color-secondary: #cfb07a;
    --color-accent: #cf7046;
    --color-fresh: #d9e7a8;
    --color-text: #212121;
    --color-muted: #6f665d;
    --color-border: rgba(45, 91, 79, 0.16);
    --shadow-soft: 0 12px 30px rgba(28, 33, 30, 0.08);
    --shadow-card: 0 16px 40px rgba(28, 33, 30, 0.12);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: "Fraunces", serif;
    background: var(--color-bg);
    color: var(--color-text);
    line-height: 1.65;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
  }

  h1, h2, h3 {
    font-family: "Fraunces", serif;
    color: var(--color-primary);
    letter-spacing: -0.02em;
  }

  p {
    color: var(--color-muted);
  }

  a {
    text-decoration: none;
    color: var(--color-primary);
    transition: all 0.2s ease;

    &:hover {
      color: var(--color-accent);
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  :focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 4px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      scroll-behavior: auto !important;
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  /* botón primario */
  .btn-primary {
    background: var(--color-secondary);
    color: white;
    border: none;
    padding: 0.8rem 1.6rem;
    font-weight: 600;

    &:hover {
      background: #010101ff;
      transform: translateY(-1px);
    }
  }

  .btn-secondary {
    background: transparent;
    border: 1.5px solid var(--color-primary);
    color: var(--color-primary);
    padding: 0.8rem 1.6rem;

    &:hover {
      background: var(--color-primary);
      color: white;
    }
  }

  input, select, textarea {
    border-radius: 8px;
    border: 1px solid var(--color-border);
    background: var(--color-surface-2);
    padding: 0.8rem;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
      border-color: var(--color-primary);
      box-shadow: 0 0 0 2px rgba(79, 122, 101, 0.15);
    }
  }

  ::selection {
    background: var(--color-secondary);
    color: white;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  section {
    position: relative;
  }
`;

export default GlobalStyle;
